<div style="font-size: 20px;margin-bottom:10px">Select a pumpset to customise</div>
<div style="display: inline-block;width:40%;height: 100%;">
    <dx-tree-view 
        #tree 
        id="simple-treeview" 
        [searchEnabled]="true" 
        searchMode="contains" 
        [items]="list"
        [height]="300" 
        (onItemClick)="selectItem($event)"></dx-tree-view>
    <div>
        <dx-button text="Select" style="margin-top: 10px;" (onClick)="select()" [disabled]="!selectEnabled"></dx-button>    
    </div>           
</div>
<div style="display: inline-block;width:60%;vertical-align: top;height: 100%;">                
    <dx-scroll-view *ngIf="lastSelected && lastSelected.id" showScrollbar="always" style="margin-left:10px">
        <pump-set-detail *ngIf="context=='Pumpset'" (loaded)="showPumpSetInDiagram($event)" [isUserPumpSet]="lastSelected.isUser" [pumpSetDetailId]="lastSelected.id" ></pump-set-detail>                
        <app-booster-detail *ngIf="context=='Booster'" [boosterId]="lastSelected.id"></app-booster-detail>
    </dx-scroll-view>                
</div>
